import Vue from 'vue'

Vue.mixin({
    methods: {
        /**********************************
         * Fetch data and content from WCS 
         **********************************/
        fetchDataFromWCS(config) {
            let self = this
            

            return new Promise(function (resolve, reject) {
                const axios = require('axios');

                //enrich session key with locale 
                let sessionKey = config.sessionKey + '_' + self.$store.state.locale

                if (!sessionStorage.getItem(sessionKey)) {

                    self.$store.commit("incrementShowLoader");

                    axios(config.axiosConfig).then(response => {
                        console.log(response.data);
                        sessionStorage.setItem(sessionKey, JSON.stringify(response.data)); 
                        resolve(response.data);
                    }).catch(error => {
                        console.log(error);
                        reject(error);
                    }).finally(() => {
                        self.$store.commit("decrementShowLoader");
                        keepAliveModule.main();
                    });
                }else{
                    resolve(JSON.parse(sessionStorage.getItem(sessionKey)));
                }

                
            });
        },
    }
})